import React from 'react'
import { StyleService, useStyleSheet } from '@src/style/service'
import { TouchableSection } from '@components'
import { Icon, Pill } from '@components/base'
import { openUrl } from '@src/utils'
import { useApplicationActionSheet } from '@src/hooks/useApplicationActionSheet'
import { UiPillSize, UiPillType } from '@src/types'
import { CustomEventTypes } from '@src/config'
import { useNutritionistHubTracker } from '../../hooks'

interface AddToCalendarItemProps {
  addToGoogleCalendarLink: string | null | undefined
  unauthenticatedIcsLink: string | null | undefined
}

export const AddToCalendarItem = ({
  addToGoogleCalendarLink,
  unauthenticatedIcsLink,
}: AddToCalendarItemProps) => {
  const styles = useStyleSheet(themedStyles)
  const { showActionSheet } = useApplicationActionSheet()
  const track = useNutritionistHubTracker()

  const calendarTypes = {
    'Google Calendar': addToGoogleCalendarLink,
    iCal: unauthenticatedIcsLink,
    Outlook: unauthenticatedIcsLink,
  }

  const isAddToCalendarDisabled = !addToGoogleCalendarLink

  return (
    <TouchableSection
      disabled={isAddToCalendarDisabled}
      onPress={() => {
        track(CustomEventTypes.NutritionistHubAddToCalendarTapped)
        showActionSheet({
          title: 'Select calendar',
          options: Object.keys(calendarTypes),
          callback: (selectedOption) => {
            const selectedOptionLink = calendarTypes[selectedOption as keyof typeof calendarTypes]
            if (selectedOptionLink) {
              openUrl(selectedOptionLink)
            }
          },
        })
      }}
      iconName="calendar-plus"
      accessoryLeft={
        <Icon
          name="calendar-plus"
          style={[styles.icon, isAddToCalendarDisabled && styles.disabledIcon]}
        />
      }
      title="Add to Calendar"
      style={[styles.actionOption, isAddToCalendarDisabled && styles.actionOptionDisabledText]}
      labelStyle={[
        styles.actionOptionText,
        isAddToCalendarDisabled && styles.actionOptionDisabledText,
      ]}
      tagComponent={
        isAddToCalendarDisabled && (
          <Pill text="Available soon" status={UiPillType.Warning} size={UiPillSize.S} />
        )
      }
    />
  )
}

const themedStyles = StyleService.create({
  actionOption: {
    paddingHorizontal: 0,
  },
  actionOptionText: {
    color: 'theme.text.primary',
    fontWeight: '400',
  },
  actionOptionDisabledText: {
    color: 'theme.disabled.text',
    minWidth: 112,
  },
  icon: {
    marginRight: 12,
  },
  disabledIcon: {
    color: 'theme.disabled.text',
  },
})
